/** @jsx h */
import { h } from 'preact'

// will get transform: scaleX(value) where
// value is a floating point number between 0 and 1
const ProgressBar = ({ value }) =>
  <div class='ProgressBar' />

export default ProgressBar
